module.exports = __webpack_public_path__ + "static/media/alex.b91ce622.png";